module.exports = __webpack_public_path__ + "assets/images/circle-left-chevron.1c8ae18ad1634c5d5ff114492cb31d34.svg";